import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const publicSlice = createSlice({
  name: "Public",
  initialState: {
    openDrawer: false,
    openFilterDrawer: false,
    accountAdded: false,
  },
  reducers: {
    setCardDrawerState(state, action: PayloadAction<boolean>) {
      state.openDrawer = action.payload;
    },
    setFilterDrawerState(state, action: PayloadAction<boolean>) {
      state.openFilterDrawer = action.payload;
    },
    setAddNewAccount(state, action: PayloadAction<boolean>) {
      state.accountAdded = action.payload;
    },
  },
});

export const publicSliceActions = publicSlice.actions;

export default publicSlice.reducer;
